import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme } from 'presto-mini-apps-lib';
import { PoweredByPrestoLogo } from '../../assets/images';


class PoweredByPresto extends Component {
    render() {
        return (
            <PoweredByWrapper className="powered-by">&nbsp;</PoweredByWrapper>   
        );
    }
}

export default PoweredByPresto;


const PoweredByWrapper = styled.div`
    margin: ${PrestoAppTheme.layout.commonGap};
    height: 20px;
    text-align: center;
    background: url(${PoweredByPrestoLogo}) center/contain no-repeat;
`;
